import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ContentGenerator } from "./inspiration/ContentGenerator";
import { ImageAnalyzer } from "./inspiration/ImageAnalyzer";

interface AIInspirationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onInspirationSelect: (text: string) => void;
  currentContent?: string;
}

export const AIInspirationDialog = ({
  open,
  onOpenChange,
  onInspirationSelect,
  currentContent = "",
}: AIInspirationDialogProps) => {
  const [activeTab, setActiveTab] = useState("content");

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl h-[80vh] flex flex-col p-6">
        <DialogHeader>
          <DialogTitle>AI Inspiration</DialogTitle>
          <DialogDescription>
            Generate content or analyze images to get inspiration
          </DialogDescription>
        </DialogHeader>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="flex-1 flex flex-col min-h-0">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="content">Content Generator</TabsTrigger>
            <TabsTrigger value="analyze">Image Analyzer</TabsTrigger>
          </TabsList>

          <div className="flex-1 overflow-y-auto p-1">
            <TabsContent value="content" className="h-full mt-4 space-y-4">
              <ContentGenerator 
                onInspirationSelect={onInspirationSelect} 
                onClose={handleClose}
              />
            </TabsContent>

            <TabsContent value="analyze" className="h-full mt-4">
              <ImageAnalyzer 
                onInspirationSelect={onInspirationSelect}
                onClose={handleClose}
              />
            </TabsContent>
          </div>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};